import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const IMG_TYPES = ["image/png", "image/jpeg", "image/webp", "image/svg+xml", "image/gif"];

export const ArtPicker = ({ side, area, hasArt, onSet }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!IMG_TYPES.includes(f.type)) return toast.error("For the live preview use a PNG, JPG, WEBP or SVG. Other files (AI, PDF, EPS) can be added at checkout.");
    setBusy(true);
    try {
      const src = URL.createObjectURL(f);
      const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads/artwork", fd);
      const aspect = img.naturalHeight / img.naturalWidth || 1;
      const w = Math.min((area.w / 100) * 0.8, ((area.h / 100) * 0.8) / aspect);
      onSet({ src, aspect, path: data.path, filename: data.filename, w, rot: 0, cx: (area.x + area.w / 2) / 100, cy: (area.y + area.h / 2) / 100 });
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="btn-red w-full" data-testid={`design-upload-${side}-button`}>
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />} {hasArt ? "Replace" : "Upload"} {side} logo
      </button>
      <input ref={ref} type="file" hidden accept="image/png,image/jpeg,image/webp,image/svg+xml,image/gif" onChange={pick} data-testid={`design-upload-${side}-input`} />
    </>
  );
};
